import './assets/css/theme.css';
import './assets/css/reset.css';
import './assets/css/base.css';
import './i18n.ts';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { GlobalContextProvider } from './components/GlobalContext.tsx';
import TextGen from './components/TextGen.tsx';

const router = createBrowserRouter([{ path: '/*', element: <TextGen /> }]);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <GlobalContextProvider>
      <RouterProvider router={router} />
    </GlobalContextProvider>
  </React.StrictMode>,
);
